var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.legends),function(legend){return _c('ChartLegend',{key:legend.color,attrs:{"legend":legend}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }